import { UserDetailsPage } from 'features/users';

export const TechOperatorUserDetailsPage: React.FC = () => <UserDetailsPage />;
